var _ellipse, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 52,
    viewBox: "0 0 55 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 27.1,
    cy: 26.2258,
    rx: 26.9438,
    ry: 25.6935,
    fill: "#005FCB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5625 13C21.3125 13 24.3125 19.75 24.3125 20.5C24.3125 22 22.0625 23.5 21.3125 25C20.5625 26.5 22.0625 28 23.5625 29.5C24.1475 30.085 26.5625 32.5 28.0625 31.75C29.5625 31 31.0625 28.75 32.5625 28.75C33.3125 28.75 40.0625 31.75 40.0625 32.5C40.0625 35.5 37.8125 37.75 35.5625 38.5C33.3125 39.25 31.8125 39.25 28.8125 38.5C25.8125 37.75 23.5625 37 19.8125 33.25C16.0625 29.5 15.3125 27.25 14.5625 24.25C13.8125 21.25 13.8125 19.75 14.5625 17.5C15.3125 15.25 17.5625 13 20.5625 13Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5625 19.06C30.5525 19.525 31.4525 20.155 32.2025 20.92C32.9375 21.655 33.5525 22.54 34.0025 23.5",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0625 13.375C33.1775 13.93 35.0675 15.025 36.5675 16.525C38.0525 18.025 39.1475 19.9 39.6875 22",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelIcon);
export default __webpack_public_path__ + "static/media/telIcon.7fe3c318f9cb24241e8f481407c111a2.svg";
export { ForwardRef as ReactComponent };